function SubmittalMoveToTrackedIcon({
  size = 16,
  className = "fill-ciq-primary-900",
  opacity = "1"
}: {
  size?: number;
  className?: string;
  opacity?: string;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M15 7.5H13.5V3H7.18935L5.68934 1.5H1.5V12H8.25V13.5H0.75C0.33579 13.5 0 13.1642 0 12.75V0.75C0 0.33579 0.33579 0 0.75 0H6.31065L7.81065 1.5H14.25C14.6642 1.5 15 1.83579 15 2.25V7.5ZM12 10.5V7.875L15.75 11.25L12 14.625V12H9.75V10.5H12Z"
        fill="currentColor"
        fillOpacity={opacity}
      />
    </svg>
  );
}

export default SubmittalMoveToTrackedIcon;
